export class ApiBase {
  protected transformOptions(options: any): Promise<any> {
    const token = localStorage.getItem('token'); // if using JWT
    if (token) options.headers['Authorization'] = `Bearer ${token}`;

    const viewAsWorkspace = localStorage.getItem('viewAsWorkspaceId');
    if (viewAsWorkspace) options.headers['X-View-As-Workspace'] = viewAsWorkspace;

    return Promise.resolve(options);
  }

  /**
   * Extracts and cleans error messages from ApiException.
   * Handles JSON-stringified responses from the backend (removes quotes).
   */
  static getCleanErrorMessage(error: any, fallback: string = 'An error occurred'): string {
    let msg = error?.response || error?.message || fallback;
    try {
      msg = JSON.parse(msg);
    } catch {
      // If not JSON, use as-is
    }
    return msg;
  }
}
